import { Component, OnInit } from '@angular/core';
import { Translators } from 'src/app/services/shared/translators.service';

@Component({
  selector: 'app-authentication-layout',
  templateUrl: './authentication-layout.component.html',
  styleUrls: ['./authentication-layout.component.scss']
})
export class AuthenticationLayoutComponent implements OnInit {

  constructor(private translatorService: Translators) { }

  ngOnInit(): void {
  }

}
